<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             top='3vh' @close='dialogClose' width='1050px' append-to-body class='dialogForm'>
    <div class='invoice' v-loading='dialogLoading'>
      <div class='title'> {{ invoiceInfo.title }}</div>
      <div class='version'> {{ invoiceInfo.version }}</div>
      <div class='basic-info'>
        <div class='basic-info-left'>
          <div>发票代码：<span>{{ invoiceForm.invoiceCode || '' }}</span></div>
          <div>发票号码：<span>{{ invoiceForm.invoiceNo || '' }}</span></div>
        </div>
        <div class='basic-info-right'>开票日期：
          <div>{{ invoiceForm.createTime || '' }}</div>
        </div>
      </div>
      <div class='box'>
        <div class='header'>
          <div class='one'>
            <div>购</div>
            <div>买</div>
            <div>方</div>
          </div>
          <div class='two'>
            <div class='content'>
              <div class='label'>
                <div>名</div>
                <div>称：</div>
              </div>
              <div class='value'>{{ invoiceForm.purchaserName }}</div>
            </div>
            <div class='content'>
              <div class='label'>
                <div>纳</div>
                <div>税</div>
                <div>人</div>
                <div>识</div>
                <div>别</div>
                <div>号：</div>
              </div>
              <div class='value'>{{ invoiceForm.purchaserDentificaNumber }}</div>
            </div>
            <div class='content'>
              <div class='label'>
                <div>地</div>
                <div>址</div>
                <div>、</div>
                <div>电</div>
                <div>话：</div>
              </div>
              <div class='value'> {{ invoiceForm.purchaserAddressAndPurchaserTel }}</div>
            </div>
            <div class='content'>
              <div class='label'>
                <div>开</div>
                <div>户</div>
                <div>行</div>
                <div>及</div>
                <div>账</div>
                <div>号：</div>
              </div>
              <div class='value'>
                {{ invoiceForm.purchaserBankDepositAndPurchaserBankAccount }}
              </div>
            </div>
          </div>
          <div class='three'>
            <div>密</div>
            <div>码</div>
            <div>区</div>
          </div>
          <div class='four'>
            {{ }}
          </div>
        </div>
        <div class='table'>
          <el-table
            :data='invoiceForm.invoiceListlVoList'
            max-height='250px'
            :header-cell-style='headerCellStyle'
            style='width: 100%' border>
            <el-table-column prop='serviceName' label='货物或应税劳务、服务名称' align='center' width='200' />
            <el-table-column prop='specificaMode' label='规格型号' align='center' />
            <el-table-column prop='unit' label='单位' align='center' />
            <el-table-column prop='settlementNum' label='数量' align='center' />
            <el-table-column prop='unitPrice' label='单价（含税）' align='center' />
            <el-table-column prop='taxPrice' label='金额（含税）' align='center' />
            <el-table-column prop='taxRate' label='税率' align='center' :formatter='taxRateFormat' />
            <el-table-column prop='tax' label='税额' align='center' />
          </el-table>
        </div>
        <div class='total'>
          <div class='number'>
            <div class='label'>
              <div>合</div>
              <div>计</div>
            </div>
            <div class='value ml-10'> ￥{{ invoiceForm.taxPriceTotal }}</div>
            <div class='value'> ￥{{ invoiceForm.taxTotal }}</div>
          </div>
          <div class='capital'>
            <div class='label'>
              <div>价</div>
              <div>税</div>
              <div>合</div>
              <div>计</div>
              <div>（</div>
              <div>大</div>
              <div>写</div>
              <div>）</div>
            </div>
            <div class='value'>{{ invoiceForm.taxPriceTotalChinese }}</div>
            <div class='value'>
              <span style='color: #b3a497;padding: 3px 0;'>（小写）</span>
              ￥ {{ invoiceForm.taxPriceTotal }}
            </div>
          </div>
        </div>
        <div class='footer'>
          <div class='one'>
            <div>销</div>
            <div>售</div>
            <div>方</div>
          </div>
          <div class='two'>
            <div class='content'>
              <div class='label'>
                <div>名</div>
                <div>称：</div>
              </div>
              <div class='value'>{{ invoiceForm.sellerName }}</div>
            </div>
            <div class='content'>
              <div class='label'>
                <div>纳</div>
                <div>税</div>
                <div>人</div>
                <div>识</div>
                <div>别</div>
                <div>号：</div>
              </div>
              <div class='value'>{{ invoiceForm.sellerDentificaNumber }}</div>
            </div>
            <div class='content'>
              <div class='label'>
                <div>地</div>
                <div>址</div>
                <div>、</div>
                <div>电</div>
                <div>话：</div>
              </div>
              <div class='value'>{{ invoiceForm.sellerAddressAndSellerTel }}</div>
            </div>
            <div class='content'>
              <div class='label'>
                <div>开</div>
                <div>户</div>
                <div>行</div>
                <div>及</div>
                <div>账</div>
                <div>号：</div>
              </div>
              <div class='value'> {{ invoiceForm.sellerBankDepositAndSellerBankAccount }}</div>
            </div>
          </div>
          <div class='three'>
            <div>备</div>
            <div>注</div>
          </div>
          <div class='four'>
            {{ invoiceForm.remark }}
          </div>
        </div>
      </div>
      <div class='people'>
        <div>收款人：<span>{{ invoiceForm.payee }}</span></div>
        <div>复核：<span>{{ invoiceForm.reviewer }}</span></div>
        <div>开票人：<span>{{ invoiceForm.drawer }}</span></div>
        <div>销售方：（章）</div>
      </div>
      <div class='btnContainer mt10'>
        <el-button size='medium' class='searchBtn' @click='submitBilling'> 确定</el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </div>
  </el-dialog>

</template>

<script>
  import {
    getInvoiceDetail,
    vehicleSettlementRejectOrSubmit,
  } from '@/service/financial';

  export default {
    name: 'submitBilling',
    data() {
      return {
        reconciliationID:'',
        dialogTitle: '提交开票',
        dialogVisible: false,
        dialogLoading: false,
        invoiceForm: {},
        invoiceInfo: {
          title: '重庆增值税专用发票',
          version: '税收分类编码版本号：40.0',
        },
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '26px',
          'background': '#cce1f5',
        },
      };
    },
    methods: {
      submitBilling() {
        this.$confirm('确认要提交开票当前数据么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await vehicleSettlementRejectOrSubmit({
              type: 1,
              id: this.reconciliationID,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.dialogClose();
            this.$emit('searchBtn');
          });
      },
      dialogOpen(row) {
        this.dialogVisible = true;
        this.getDetail(row.id);

      },
      async getDetail(id) {
        this.reconciliationID=id;
        this.dialogLoading = true;
        const {
          status,
          message,
          data,
        } = await getInvoiceDetail(id);
        this.dialogLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.invoiceForm = data;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.invoiceForm = {};
      },
      taxRateFormat(r, c, cellValue) {
        return cellValue + '%';
      },
    },
  };
</script>

<style lang='scss' scoped>
  .invoice {
    padding: 10px;
    font-size: 18px;
    font-weight: 400;

    .title {
      text-align: center;
      color: #ac6252;
      font-size: 22px;
      font-weight: 500;
    }

    .version {
      text-align: right;
      color: #c6c9cd;
      font-size: 16px;
    }

    .basic-info {
      margin-top: 5px;
      display: flex;

      .basic-info-left {
        display: flex;
        width: 70%;
        color: #86410e;
        font-weight: 700;

        div {
          width: 250px;
          font-weight: 700;

          span {
            color: red;
            margin-right: 10px;
            font-weight: 700;
          }
        }
      }

      .basic-info-right {
        display: flex;
        justify-content: flex-end;
        width: 30%;
        text-align: right;
        color: #86410e;
        font-weight: 700;

        div {
          width: 145px;
          color: #000;
          font-weight: 700;
        }
      }
    }

    .box {
      border: 3px solid #ab4807;
      margin-top: 5px;

      .header {
        .one, .three {
          border-right: 3px solid #ab4807;
          border-bottom: 3px solid #ab4807;
        }

        .two {
          border-right: 3px solid #ab4807;
          border-bottom: 3px solid #ab4807;
        }

        .four {
          border-bottom: 3px solid #ab4807;
        }
      }

      .footer {
        .one, .three {
          border-right: 3px solid #ab4807;
        }

        .two {
          border-right: 3px solid #ab4807;
        }
      }

      .header, .footer {
        display: flex;

        .one, .three {
          width: 5%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          color: #b3a497;
        }

        .two {
          padding: 5px;
          width: 60%;

          .content {
            display: flex;
            align-items: center;
            padding: 3px;

            .label {
              width: 130px;
              display: flex;
              justify-content: space-between;
              color: #b3a497;
            }

            .value {
              width: calc(100% - 130px);
            }
          }
        }

        .four {
          padding: 3px;
          width: 30%;
        }
      }

      .table {
        height: 250px;
      }

      .total {
        .number, .capital {
          display: flex;
          justify-content: space-between;
          padding: 0 80px;
          border-bottom: 3px solid #ab4807;

          .label {
            padding: 3px 0;
            display: flex;
            justify-content: space-between;
            width: 140px;
            color: #b3a497;
          }

          .value {
            padding: 3px 0;
          }

          .ml-10 {
            margin-left: -10px;
          }
        }

        .capital .label {
          border-right: 3px solid #ab4807;
          padding-right: 200px;
        }
      }
    }

    .people {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      color: #b3a497;

      span {
        color: #000;
      }
    }
  }

  ::v-deep {
    .el-table td, .el-table th {
      padding: 0;
    }
  }
</style>
